import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/builders/$builder_id/procure/$")({
  beforeLoad: ({ params }) => {
    const splat = params["_splat"] ?? "";
    throw redirect({
      to: `/builders/${params.builder_id}/estimate/${splat}` as string,
      statusCode: 301,
    });
  },
});
